module.exports = "<div class=\"panel panel-primary\">\r\n    <div class=\"panel-heading\">\r\n        Password Reset Success\r\n    </div>\r\n    <div class=\"panel-body\"  >\r\n        <div class=\"well\">\r\n            Click <a [routerLink]=\"['/login']\">here</a> to login. \r\n        </div>        \r\n    </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./app/authentication/reset-password-success.component.html
 ** module id = 908
 ** module chunks = 0
 **/